// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = "";

// ----------------------------------------------------------------------

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    // dashboard: path(ROOTS_DASHBOARD, "/dashboard"),
    // storeDashboard: path(ROOTS_DASHBOARD, "/dashboard/store-dashbord"),
    catalog: path(ROOTS_DASHBOARD, "/catalog"),
    pageTwo: path(ROOTS_DASHBOARD, "/two"),
    pageThree: path(ROOTS_DASHBOARD, "/three"),
  },
  dashboard: {
    root: path(ROOTS_DASHBOARD, "/dashboard"),
    dashboard: path(ROOTS_DASHBOARD, "/dashboard"),
    storeDashboard: path(ROOTS_DASHBOARD, "/dashboard/store-dashbord"),
  },
  orders: {
    root: path(ROOTS_DASHBOARD, "/orders"),
    pageOrders: path(ROOTS_DASHBOARD, "/orders"),
    pageList: path(ROOTS_DASHBOARD, "/orders/display_list"),
    delivery: path(ROOTS_DASHBOARD, "/orders/delivery")
  },
  masterCatalog: {
    root: path(ROOTS_DASHBOARD, "/master-catalog"),
    pageProducts: path(ROOTS_DASHBOARD, "/master-catalog/products"),
    pageDisplayCategories: path(ROOTS_DASHBOARD, "/master-catalog/display-category"),
    pageInternalCategories: path(ROOTS_DASHBOARD, "/master-catalog/internal-category"),
    pageBrandsSuppliers: path(ROOTS_DASHBOARD, "/master-catalog/brand"),
    pageCoupons: path(ROOTS_DASHBOARD, "/master-catalog/coupons"),
  },
  branchCatalog: {
    root: path(ROOTS_DASHBOARD, "/branch-catalog"),
    pageDisplayCategories: path(ROOTS_DASHBOARD, "/branch-catalog/display-category"),
    pageProducts: path(ROOTS_DASHBOARD, "/branch-catalog/products"),
  },
  catalog: {
    root: path(ROOTS_DASHBOARD, "/catalog"),
    pageCategories: path(ROOTS_DASHBOARD, "/catalog"),
    pageList: path(ROOTS_DASHBOARD, "/master-catalog/display_categories"),
  },
  promotions: {
    root: path(ROOTS_DASHBOARD, "/promotions"),
    pageCategories: path(ROOTS_DASHBOARD, "/promotions"),
  },
  homeManagement: {
    root: path(ROOTS_DASHBOARD, "/home-management"),
    pageHomeTemplate: path(ROOTS_DASHBOARD, "/home-management/home-template"),
    pageProductGroup: path(ROOTS_DASHBOARD, "/home-management/product-group"),
    pageBanner: path(ROOTS_DASHBOARD, "/home-management/banner"),
  },
  companyManagement: {
    root: path(ROOTS_DASHBOARD, "/company-management"),
    pageCategories: path(ROOTS_DASHBOARD, "/company-management"),
  },
  shopManagement: {
    root: path(ROOTS_DASHBOARD, "/shop-management"),
    pageCategories: path(ROOTS_DASHBOARD, "/shop-management"),
  },
  report: {
    root: path(ROOTS_DASHBOARD, "/report"),
    pageCategories: path(ROOTS_DASHBOARD, "/report"),
  },
  app: {
    root: path(ROOTS_DASHBOARD, "/app"),
    pageFour: path(ROOTS_DASHBOARD, "/app/four"),
    pageFive: path(ROOTS_DASHBOARD, "/app/five"),
    pageSix: path(ROOTS_DASHBOARD, "/app/six"),
  },
};
